import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'ATTENDANCES';

export default createListReducer(TEMPLATE_NAME);
